import type { ReactNode } from 'react';

type FeedIconProps = {
  children: ReactNode;
  failed: boolean;
};

// The row's 28-unit icon cell, its tile at the cell's left edge so the frame's body lines start
// where the tile does; a failed card keeps a danger dot on it, open or folded
export const FeedIcon = ({ children, failed }: FeedIconProps) => (
  <span className="relative flex size-[var(--ac-row-icon)] shrink-0 items-center justify-start">
    {children}
    {failed ? (
      <span
        data-testid="feed-failed-dot"
        aria-hidden="true"
        className="absolute right-[calc(2*var(--ac-u))] top-0 size-[calc(8*var(--ac-u))] rounded-full bg-danger-9 ring-2 ring-background"
      />
    ) : null}
  </span>
);
